import { debounce } from "./utility";

const is_active = window.matchMedia( '(max-width: 767px)' );

document.querySelectorAll( '.block-three-feat' ).forEach( features => {
    let interval;

    set_state();
    window.addEventListener( 'resize', debounce( set_state, 300 ), { passive: true } );

    function set_state() {
        if ( is_active.matches && !interval ) {
            interval = set_up_sliding();
        } else if ( !is_active.matches && interval ) {
            break_down_sliding();
        }
    }

    function set_up_sliding() {
        const items = features.querySelectorAll( '.item' );
        const base = items.length;
        let step = 0;

        return setInterval( () => {
            nextStep();
        }, 3500 );

        function nextStep() {
            step += 1;
            features.style.transform = `translateX(${-100 * ( step % base )}%)`;
        }
    }

    function break_down_sliding() {
        features.style.transform = null;
        clearInterval( interval );
        interval = null;
    }
} );
